"use client";

import Link from "next/link";
import Image from "next/image";
import { Code } from "lucide-react";

export function Header() {
  return (
    <div className="sticky top-0 z-50 bg-background border-border border-dotted border-b-1">
      <div className="flex items-center justify-between max-w-screen-xl px-4 sm:px-8 mx-auto border-border border-dotted border-r-1 border-l-1">
        <Link
          href="https://starterkitpro.com"
          className="flex space-x-2 py-3 items-center"
        >
          <h1 className="text-xl font-bold flex items-center gap-2">
            <Image
              src="/logo.png"
              alt="StarterKitPro Blocks"
              width={24}
              height={24}
            />
            Blocks
          </h1>
        </Link>
        <div className="flex items-center gap-2">
          <Link
            href="https://starterkitpro.com"
            className="py-2 rounded-full flex justify-center items-center px-5 group transition-all duration-300 bg-[#fee2ff] ring-1 ring-[#f82dff] hover:saturate-[1.2] hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] text-black"
            aria-label="Visit StarterKitPro"
          >
            <Code className="mr-2 size-5 transition-transform group-hover:rotate-12 text-black" />
            <span className="text-base font-semibold text-black">
              Get StarterKitPro
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}
